module.exports = __webpack_public_path__ + "img/send-03.9f6c5e6d.svg";